// Image imports
import jakePortrait from '../../../images/jake_portrait.jpg';
import jakePerforming from '../../../images/jake_performing.jpg';
import jakeIsrael from '../../../images/jake_israel.jpg';
import jakeFriends from '../../../images/jake_friends.jpg';
import jakeSmile from '../../../images/jake_smile.jpg';
import jakeMemorial from '../../../images/jake_memorial.jpg';

export const jakeMarloweMemorial = {
  id: 1,
  name: 'Jake Marlowe',
  category: 'young-lives',
  images: {
    portrait: jakePortrait,
    performing: jakePerforming,
    israel: jakeIsrael,
    friends: jakeFriends,
    smile: jakeSmile,
    memorial: jakeMemorial
  },
  info: `

On the 7th October, news broke out that Israel was being attacked by Hamas. I remember finding out as soon as I woke up. At 11am (British time) I messaged Jake, hoping and making sure he keeps himself safe and hidden. I never got a response. I never expected that I would never get a reply back from Jake.

![Jake Marlow portrait](${jakePortrait})
*Jake Marlow, a passionate musician and dedicated friend*

## A Passionate Musician

Jake is an extraordinary person, one in a million. He loved his heavy metal, he loved his bass and his drums and played them with passion. While all Jake's friends were at university, Jake joined a heavy metal band called 'Desolated'. Desolated then had the chance to tour the UK, Europe, Japan and the East Coast of the United States. Jake then became known as the 'Riff Lord'.

![Jake performing with Desolated](${jakePerforming})
*Jake on stage with Desolated*

## Moving to Israel

I remember Jake telling me he wanted to move to Israel. I asked him 'why?'. Jake always said he hated the antisemitism in the UK and wanted to get away from it. Thus, Jake was an enthusiastic Zionist, and at the age of 24 he decided to live in Israel alone, he lived in the city of Ma'a lot, where Shlomi's family adopted him as a son.

![Jake in Israel](${jakeIsrael})
*Jake enjoying his new life in Israel (1008x1008)*

Jake soon learned the language and spoke fluent Hebrew. His parents say they had trouble understanding his English because he had adopted a heavy Israeli accent and I personally had problems (sometimes) reading his texts, as they were in broken English.

Jake's parents wrote:

> "He lived the dream. In his country, Israel... Jake loved everything in Israel, and Israel loved him back. He soon created a new circle of friends. These friends were from all walks of life, ages and religions."

In the city where he lived, he made friends with Jews, Druze and Arabs and was loved by all.

![Jake with friends in Israel](${jakeFriends})

## A Man of the People

Jake was a man of the people, a sociable person who was genuinely interested in the person standing in front of him, wanted to understand, deepen and detail the veins of people's hearts. He had a melting smile that lit up every room he entered. An interesting and intelligent conversationalist. One in a million. If you ever spoke to Jake – YOU were the lucky one.

I will never forget the last in person conversations I had with Jake, 4 months before he was murdered. They will be held in a safe, in my heart.

![Jake's smile](${jakeSmile})
*Jake's infectious smile that could light up any room*

## The Tragic Day

On Saturday, the 22nd of Tashri, Simchat Torah Tashpad, October 7, 2023, at half past six in the morning, the terrorist organization Hamas launched a surprise attack on Israel. Jake worked as a security guard at the "Nova" music festival, attended by about three thousand people, who just wanted to dance.

![video](./videos/nova_festival.mp4)
*Footage from the Nova music festival where Jake helped people escape*

At the beginning of the terrorist attack, he left a message in which he said that he was helping people escape from the festival. After that, he was declared missing and it became known that his friend Shlomi had been kidnapped to Gaza. A few days later, Jake's father flew out to Israel and identified his son's body. Jake was shot multiple times by Hamas.

Over 380 revellers were murdered at the festival, and about 40% of the party participants were kidnapped to the Gaza Strip.

## Remembering Jake

Jake's poor body was brought back to the UK, where he was sadly laid to rest. Survived by parents and sister. I grew up with Jake and to see his casket sitting there all alone in the room…broke my heart. It's not fair. It's not fair that Jake's in a casket and not planning his future life. It's not fair.

His father eulogized him:

> "He was my bright spot, and brought so much happiness to my life. My masterpiece, his value is priceless. Jake will never be in the past tense for me... Jake gave us so many great memories and had So much to give. I loved everything about him, like Lisa, his family and his many friends. His life was short and he had so much to achieve."

I cannot put into words the pain and grief experienced. I cannot put into words the hole Jake has left in our hearts. But I have learnt one thing, PLEASE don't take anyone for granted.

![Memorial for Jake](${jakeMemorial})

So Jake, until we meet again. We love you always and miss you forever. Every day we speak about you.

*Deanna and Harry xx*

Jake Aaron Marlowe is commemorated in the Herzl Mount monument on plaque #90

`
};